import type { ApiFetchPerformanceStats } from '@/utils/apiPerformanceLogger';
import type { GlobalState } from '../rootReducer';

export type PerformanceLog = {
    stats: ApiFetchPerformanceStats;
    url: string;
};

export type State = {
    client: PerformanceLog;
    server: PerformanceLog;
};

export const DEFAULT_STATE: State = {
    client: null,
    server: null,
};

export type LogClientPerformanceStatsAction = {
    payload: PerformanceLog;
    type: 'LOG_CLIENT_PERFORMANCE_STATS';
};

export type LogServerPerformanceStatsAction = {
    payload: PerformanceLog;
    type: 'LOG_SERVER_PERFORMANCE_STATS';
};

type Actions = LogClientPerformanceStatsAction | LogServerPerformanceStatsAction;

const reducer = (state = DEFAULT_STATE, action: Actions): State => {
    switch (action.type) {
        case 'LOG_CLIENT_PERFORMANCE_STATS':
            return {
                ...state,
                client: action.payload,
            };
        case 'LOG_SERVER_PERFORMANCE_STATS':
            return {
                ...state,
                server: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;

/* SELECTORS */
export const getApiPerformanceStats = (state: GlobalState): State => state.apiPerformanceStats;
